module.exports = __webpack_public_path__ + "Flag-524.7baf61c68c0f4c10077eae9bbf29e1bd.svg";